<template>
  <main>
    <article class="row left-align">
      <section class="col s9">
        <router-link to="/tickeradmin/listservices" class="blue-grey-text text-darken-4 strong">Security Master</router-link>
        >
        <span>Edit Recommendation (Multi)</span>
      </section>
      <section class="col s3 right-align">
        <router-link to="/tickeradmin/editrecquick" class="blue-grey-text text-darken-4 strong">
          <div class="switch">
            <label>
              Single
              <input type="checkbox" checked>
              <span class="lever" />
              Multiple
            </label>
          </div>
        </router-link>
      </section>
    </article>
    <h4>
      Edit Recommendation
    </h4>
    <article class="row">
      <look-ahead id="edit-recs-multi-lookead-instrument"
                  name="Instrument"
                  size="s5"
                  :picks="instrumentPicks"
                  watermark="MSFT or Microsoft"
                  @searched="searchInstruments"
                  @picked="instrumentId = Number($event.slice(1, $event.indexOf(' ')))"
      />
      <autocomplete id="edit-recs-multi-autocomplete-portfolio"
                    name="Portfolio"
                    size="s5"
                    :picks="portfolioPicks"
                    watermark="Rule Breakers"
                    @picked="portfolioId = Number($event.slice(1, $event.indexOf(' ')))"
                    v-if="portfolioPicks.length"
      />
      <section class="input-field col s2">
        <a class="waves-effect waves-light btn-small light-blue accent-4 "
           @click="fetchRecommendations"
           :disabled="!instrumentId || !portfolioId"
        >
          Search
        </a>
      </section>
    </article>
    <article class="row" v-show="recommendations.length">
      <section class="col s12">
        <article class="row">
          <table>
            <thead>
              <tr>
                <th>#</th>
                <th>Open Date</th>
                <th class="center-align">Close Date</th>
                <th>Ticker</th>
                <th>Name</th>
                <th>Portfolio</th>
                <th class="center-align">Selected</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="recommendation of recommendations" :key="recommendation.id">
                <td>{{ recommendation.id }}</td>
                <td>{{ recommendation.open_date }}</td>
                <td class="center-align">{{ recommendation.close_date || '-' }}</td>
                <td>{{ recommendation.instrument.ticker }}</td>
                <td>{{ recommendation.instrument.display_name || recommendation.instrument.name | pretty }}</td>
                <td>{{ recommendation.portfolio.name }}</td>
                <td class="center-align">
                  <p>
                    <label>
                      <input type="checkbox" class="filled-in" checked="checked" :value="recommendation.id" v-model="recommendationIdsChecked">
                      <span />
                    </label>
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </article>
        <article class="row">
          <section class="input-field col s3">
            <input id="edit-recs-multi-close-date"
                   type="text"
                   class="datepicker left"
                   @change="close_date = $event.target.value"
            >
            <label class="active" :class="{'blue-text': !$auth.hasRoles('admin')}">
              Close Date
            </label>
          </section>
          <section class="col s6" />
          <section class="col s3" style="margin-top: 10px;">
            <input class="btn waves-effect waves-light teal accent-4 right"
                   type="submit"
                   value="Submit"
                   @click="saveRecommendations"
                   :disabled="!recommendationIdsChecked.length || !close_date"
            >
          </section>
        </article>
        <article class="row" v-show="waiting">
          <section class="col s12 progress">
              <aside class="indeterminate" />
          </section>
        </article>
      </section>
    </article>
  </main>
</template>

<script>
import axios from 'axios';
import LookAhead from '@/components/LookAhead.vue';
import Autocomplete from '@/components/Autocomplete.vue';

export default {
  name: 'TickerAdminEditRecMulti',
  components: { LookAhead, Autocomplete },
  props: {},
  data() {
    return {
      recommendations: [],
      instruments: [],
      portfolios: [],
      portfolioId: 0,
      instrumentId: 0,
      recommendationIdsChecked: [],
      close_date: '',
      waiting: false,
    };
  },
  computed: {
    instrumentPicks() {
      return this.instruments.map(instrument => `#${instrument.InstrumentId} ${instrument.Exchange}:${instrument.Symbol} ${instrument.Name}`);
    },
    portfolioPicks() {
      return this.portfolios.map(portfolio => `#${portfolio.id} ${portfolio.name} (${portfolio.slug})`);
    },
  },
  watch: {},
  methods: {
    initDatepicker() {
      this.materialize.Datepicker.init(document.querySelectorAll('.datepicker'), {
        autoClose: false,
        format: 'yyyy-mm-dd',
        disableWeekends: true,
        showDaysInNextAndPreviousMonths: true,
        showClearBtn: true,
        onSelect() {},
      });
    },
    async fetchPortfolios() {
      const { data } = await axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/recommendations/portfolios/`);
      this.portfolios = data.filter(portfolio => portfolio.portfolio_type === 'notional');
    },
    async searchInstruments(value) {
      const { data } = await axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/quotes/instruments/search/?q=${query}`);
      this.instruments = data.SearchResults;
    },
    async fetchRecommendations() {
      const { data } = await axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/recommendations/recommendations/?portfolio_id=${this.portfolioId}&instrument_id=${this.instrumentId}`);
      this.recommendations = data;
      if (!data.length) {
        this.toast('No recommendations found', 'pink');
      }
    },
    async saveRecommendations() {
      const promises = this.recommendationIdsChecked.map(recommendationId => {
        const payload = {
          analyst_id: this.$auth.user.pk,
          recommendation_id: recommendationId,
          close_date: this.close_date,
        };
        return axios.put(`${this.$store.getters.VUE_APP_APING_URL}/insights/recommendations/recommendation/`, payload);
      });
      this.waiting = true;
      const promiseResps = await Promise.all(promises);
      this.toast('Saved recommendations!', 'green');
      document.getElementById('edit-recs-multi-lookead-instrument').value = '';
      document.getElementById('edit-recs-multi-autocomplete-portfolio').value = '';
      document.getElementById('edit-recs-multi-close-date').value = '';
      this.recommendations = [];
      this.instruments = [];
      this.portfolioId = 0;
      this.instrumentId = 0;
      this.recommendationIdsChecked = [];
      this.close_date = '';
      this.waiting = false;
    },
  },
  mounted() {
    this.initDatepicker();
    this.fetchPortfolios();
  },
};
</script>
